'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002ecomponents$002e$002dMui$002dComponents$0024$002dMui$002dIcon from "./mealorama.components.-Mui-Components$-Mui-Icon.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$21() {
  this.hO = null;
  $j_mealorama$002ecomponents$002e$002dMui$002dComponents$0024$002dMui$002dIcon.$ct_Lmealorama_components_MuiComponents$MuiIcon__T__(this, "arrow_forward");
}
export { $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$21 as $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$21 };
$p = $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$21.prototype = new $j_mealorama$002ecomponents$002e$002dMui$002dComponents$0024$002dMui$002dIcon.$h_Lmealorama_components_MuiComponents$MuiIcon();
$p.constructor = $c_Lmealorama_components_MuiComponents$MuiIcon$$anon$21;
/** @constructor */
function $h_Lmealorama_components_MuiComponents$MuiIcon$$anon$21() {
}
export { $h_Lmealorama_components_MuiComponents$MuiIcon$$anon$21 as $h_Lmealorama_components_MuiComponents$MuiIcon$$anon$21 };
$h_Lmealorama_components_MuiComponents$MuiIcon$$anon$21.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return "ArrowForward";
});
$p.m = (function() {
  return "ArrowForward";
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("ArrowForward");
});
var $d_Lmealorama_components_MuiComponents$MuiIcon$$anon$21 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MuiComponents$MuiIcon$$anon$21, "mealorama.components.MuiComponents$MuiIcon$$anon$21", ({
  HM: 1,
  ag: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_components_MuiComponents$MuiIcon$$anon$21 as $d_Lmealorama_components_MuiComponents$MuiIcon$$anon$21 };
//# sourceMappingURL=mealorama.components.-Mui-Components$-Mui-Icon$$anon$21.js.map
